import React from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "types/store";
import styles from "./style.module.css";
import moment from "moment";
import { TileTitle, Tile, TileBody, TileItem } from "aible";
import { createTone, deleteTone, getToneList, isDefaultTone } from "containers/ChatTone/reducer";
import { updateType, VIEW_TYPE } from "containers/View/reducer";
import MessageIconPurple from "images/message-lines-purple.svg";
import MessageIconWhite from "images/message-lines-white.svg";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as loginReducer from "containers/Login/reducer";
import { getSelectedFolder } from "containers/Folders/reducer";
import { toast } from "react-toastify";
import * as viewReducer from "containers/View/reducer";
const ChatToneView = ({} = {}) => {
    const dispatch = useDispatch();
    const DEFAULT_TILES = [
        {
            title: "Import Chat Tone",
            description: "Import an exported tone from your clipboard",
            type: "IMPORT"
        },
        {
            title: "Create New Chat Tone",
            description: "Create a new chat tone with custom instructions",
            type: "CREATE"
        }
    ];
    const chatTones = useSelector((state) => getToneList(state)) || [];
    const searchText = useSelector((state) => viewReducer.getSearch(state));
    const retData = chatTones.filter((d) => d.name.toLowerCase().includes(searchText.toLowerCase()));
    return (React.createElement("div", { className: styles.chatToneView },
        React.createElement("div", { className: styles.chatToneTiles },
            DEFAULT_TILES &&
                DEFAULT_TILES.map((tile, i) => {
                    return React.createElement(DefaultTile, { data: tile });
                }),
            retData.map((tone, i) => {
                return React.createElement(ChatToneTile, { tone: tone, key: "chatToneTile__" + i });
            }))));
};
const ChatToneTile = ({ tone }) => {
    const dispatch = useDispatch();
    const [isLoading, updateIsLoading] = useState(false);
    const isDefault = isDefaultTone(tone);
    const userID = useSelector((state) => loginReducer.getUserID(state));
    const isToneCreator = "created_by" in tone && tone?.created_by?.id === userID ? true : false;
    const disableDelete = isDefault || !isToneCreator;
    const retCreator = "created_by" in tone ? (tone?.created_by?.fullname ?? tone?.created_by) : undefined;
    const createdDate = "created_date" in tone ? moment.utc(tone?.created_date).local().fromNow() : undefined;
    const handleInitChatWithTone = () => {
        dispatch(updateType(VIEW_TYPE.NEW_CHAT));
        dispatch(chatGPTReducer.updateChatTone(tone?.id));
    };
    const handleDeleteTone = () => {
        updateIsLoading(true);
        dispatch(deleteTone(tone)).then(() => {
            updateIsLoading(false);
        });
    };
    const handleExportTone = () => {
        const retLabel = tone?.name;
        const exportTone = {
            name: retLabel,
            metadata: {
                ...tone.metadata
            }
        };
        toast(`Tone: ${tone?.name} copied to clipboard.`, {
            type: toast.TYPE.SUCCESS,
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3500
        });
        navigator.clipboard.writeText(JSON.stringify(exportTone));
    };
    const handleEditTone = () => {
        dispatch(chatGPTReducer.openChatSettingView("TONE"));
        dispatch(chatGPTReducer.updateChatTone(tone?.id));
    };
    return (React.createElement(Tile, { onClick: () => handleInitChatWithTone(), handleDelete: () => handleDeleteTone(), hideDelete: disableDelete, buttonText: "Use Chat Tone", onClickSecond: (e) => {
            e.stopPropagation();
            handleEditTone();
        }, secondButton: "Edit Tone", key: "chatTone" + tone?.id },
        React.createElement(TileTitle, { title: tone?.name, icon: React.createElement("img", { className: styles.toneTileIcon, src: MessageIconWhite }), color: "#4A90E2" }, tone?.name),
        React.createElement(TileBody, { isLoading: false },
            React.createElement(TileItem, { icon: "link", onClick: () => {
                    handleExportTone();
                } }, retCreator ?? "Aible"),
            React.createElement(TileItem, { icon: "user" }, retCreator ?? "Aible"),
            createdDate && (React.createElement(TileItem, { icon: "calendar", overlay: "created_date" in tone
                    ? moment.utc(tone.created_date).local().format("MMMM Do YYYY, h:mm:ss a")
                    : undefined }, createdDate)))));
};
const DefaultTile = ({ data }) => {
    const dispatch = useDispatch();
    const isCreatingTone = useSelector((state) => chatGPTReducer.getIsCreatingTone(state));
    const folderId = useSelector(getSelectedFolder);
    const updateChatTone = (val) => dispatch(chatGPTReducer.updateChatTone(val));
    const handleClick = () => {
        if (data?.type === "CREATE" && !isCreatingTone) {
            dispatch(chatGPTReducer.openChatSettingView("TONE"));
            dispatch(chatGPTReducer.updateIsCreatingTone(true));
        }
        else if (isCreatingTone) {
            dispatch(chatGPTReducer.updateIsCreatingTone(false));
        }
        if (data?.type === "IMPORT") {
            navigator.clipboard.readText().then((importedTone) => {
                if (importedTone) {
                    try {
                        const parsedTone = JSON.parse(importedTone);
                        parsedTone.folder_id = folderId;
                        dispatch(createTone(parsedTone)).then((tone) => {
                            updateChatTone(tone?.id);
                            toast(`Tone: ${tone?.name} was imported.`, {
                                type: toast.TYPE.SUCCESS,
                                position: toast.POSITION.TOP_CENTER,
                                autoClose: 3500
                            });
                        });
                    }
                    catch (e) {
                        console.log(e);
                        toast(`${e}`, {
                            type: toast.TYPE.ERROR,
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 3500
                        });
                    }
                }
            });
        }
        return;
    };
    return (React.createElement(Tile, { key: "defaultTile_" + data?.type, isTileClick: true, onClick: () => {
            handleClick();
        }, buttonText: data?.title, showButton: true },
        React.createElement(TileBody, { isLoading: false },
            React.createElement("div", { className: styles.defaultToneTileIconWrapper },
                React.createElement("div", { className: styles.defaultToneTileIcon },
                    React.createElement("img", { src: MessageIconPurple, alt: data?.title }))))));
};
export default ChatToneView;
